import 'lightgallery/dist/js/lightgallery.js';
import 'lg-fullscreen/dist/lg-fullscreen.js';
import 'lg-thumbnail/dist/lg-thumbnail.js';
import 'lg-zoom/dist/lg-zoom.js';

export default {
  finalize() {
    $('.single-project-gallery').lightGallery({
      selector: '.single-project-gallery .gallery-image',
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/gallery.js